import bem from 'utils/bem';

export const block = bem('preview-pane');
